import { TERMS } from './terms'

export const HOUSE_ELEMENT = {
  noTypesAvailable:
    'Es sind keine aktiven Element-Typen verfügbar. Lege zuerst einen Typ in den Einstellungen an.',
  orphanedTypesHint:
    'Diese Instanzen verweisen auf Typen, die es nicht mehr gibt:',
  typesLoadError: `Konnte ${TERMS.elementTypePlural} nicht laden`,
  elementsLoadError: 'Konnte erfasste Anzahlen nicht laden',
  perRoomSectionTitle: 'Elemente in diesem Raum',
  propertySectionTitle: 'Elemente am Objekt',
  row: {
    deleteConfirmTitle: 'Wirklich löschen?',
    deleteConfirmMessage: (label: string) =>
      `Möchtest du die erfasste Anzahl für „${label}“ wirklich entfernen?`,
    deselect: '— keine Auswahl —',
  },
  errors: {
    quantityBelowMin: (min: number) => `Wert muss ≥ ${min} sein.`,
    quantityAboveMax: (max: number) => `Wert muss ≤ ${max} sein.`,
    decimalPlacesExceeded: (n: number) =>
      n === 0
        ? 'Nur Ganzzahlen erlaubt.'
        : n === 1
          ? `Höchstens ${n} Nachkommastelle erlaubt.`
          : `Höchstens ${n} Nachkommastellen erlaubt.`,
  },
} as const
